/* eslint-disable @nx/enforce-module-boundaries */
import Image from 'next/image';
import { Image as ImageChakra , Text} from '@mybridge/ui';
// import Image from 'next/image';
import PreloadImage from 'react-preload-image';
import { Box } from '@mybridge/ui/layout';
import { VideoPlayer } from '@mybridge/ui/video-player';
import { useContext, useEffect, useRef, useState } from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { PostBoxContext } from '../context';
import styles from './child-media-player.module.scss';
import { HStack, Stack } from '@mybridge/ui/layout';
import { Spinner } from '@chakra-ui/react';

export const ChildMediaDisplay = ({ onLoaded, post, isQuoted = false, onQuotedClick, imageAlignment = 'left', outerTimeStyle }) => {
  const { handleAdClicksRouting } = useContext(PostBoxContext);
  const { gif, media, cover_image, type, title, id, ad_format_detail } = post;
  const isArticle = type === 3;
  const isAdPost = type === 4;
  const [images_, setImages_] = useState([]);
  const [videos_, setVideos_] = useState([]);
  const [gifs_, setGifs_] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const videoRef = useRef(null);
  useEffect(() => {
    prepareMedia();
  }, [media]);

  useEffect(() => {
    prepareGifs();
  }, [gif]);

  async function prepareMedia() {
    const vids = [];
    const imgs = [];
    let processing = false;
    for (let m of media ?? []) {
      const { file, type, is_processed } = m ?? {};
      if (is_processed === false && !file) {
        processing = true;
      } else {
        if (!file) continue;
        if (
          type === 'VIDEO' ||
          file?.toLowerCase?.()?.includes?.('.mp4') ||
          file?.toLowerCase?.()?.includes?.('.mov')
        ) {
          vids.push(file);
        } else {
          imgs.push(file);
        }
      }
    }
    setIsProcessing(processing);
    setVideos_(vids);
    setImages_(imgs);
  };

  const prepareGifs = async () => {
    const gs = [];
    if (gif?.length) {
      gs.push(gif);
    }
    setGifs_(gs);
  };

  const handleLoading = (val) => {
    onLoaded?.();
  };

  const handleVideoAdDuration = (duration) => {
    if(duration?.playedSeconds > 5){
      handleAdClicksRouting('video', id);
    }
  }

  // Custom component for 5 images layout using CSS Grid
  const FiveImagesGrid = ({ images }) => {
    // Define grid positions and styles
    const gridPositions = [
      // First row (2 images)
      { gridRow: '1', gridColumn: '1', borderRadius: '20px 0 0 0' },    // Top-left
      { gridRow: '1', gridColumn: '2', borderRadius: '0 20px 0 0' },    // Top-right
      // Second row (3 images)
      { gridRow: '2', gridColumn: '1', borderRadius: '0 0 0 0' },       // Bottom-left
      { gridRow: '2', gridColumn: '2', borderRadius: '0 0 0 0' },       // Bottom-middle
      // Fifth image spans full width
      { gridRow: '3', gridColumn: '1 / -1', borderRadius: '0 0 20px 20px' } // Full-width bottom
    ];

    return (
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gridTemplateRows: '200px 200px 200px',
        gap: '2px',
        borderRadius: '20px',
        overflow: 'hidden'
      }}>
        {images.map((img, index) => (
          <div 
            key={index}
            style={{ 
              gridRow: gridPositions[index].gridRow,
              gridColumn: gridPositions[index].gridColumn,
              overflow: 'hidden'
            }}
          >
            <ImageChakra 
              src={img} 
              alt={id} 
              width="100%" 
              height="100%" 
              loading="lazy"
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                borderRadius: gridPositions[index].borderRadius
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  // console.log('ad_format_detail?.image', videoRef);

  return (
    <>
      {isProcessing ? (
        <HStack
          justifyContent="center"
          alignItems="center"
          h="300px"
          w="100%"
          bg="#F2F4F7"
          borderRadius="20px"
          p={4}
        >
          <Spinner size="md" color="blue.500" />
          <Text ml={3} color="gray.600" fontWeight="medium">
            Video is processing...
          </Text>
        </HStack>
      ) : videos_?.length ? (
        <Box 
          pos="relative" 
          overflow="hidden" 
          className={styles.mediaPlayer}
          onClick={(e) => {
            // Handle clicks on video area for quoted posts
            if (isQuoted && onQuotedClick) {
              const target = e.target;
              // Check if click is on video controls - look for specific video player control classes
              const isControlClick = 
                target.closest('[class*="controlCont"]') || // control container
                target.closest('[class*="playBtns"]') || // play/pause button
                target.closest('[class*="btnsCont"]') || // buttons container
                target.closest('[class*="barCont"]') || // progress bar container
                target.closest('input[type="range"]') || // slider controls
                target.closest('button') ||
                target.tagName === 'BUTTON' ||
                target.closest('svg') || // icon buttons
                target.closest('[role="button"]');
              
              // If clicking on video area (not controls), open windowed mode
              // Only handle if it's not a control click
              if (!isControlClick) {
                // Check if click is on the video player container, ReactPlayer, or video element
                const isVideoArea = target.closest('.player') || 
                                   target.closest('[class*="mediaPlayer"]') ||
                                   target.tagName === 'VIDEO' ||
                                   target === e.currentTarget;
                
                if (isVideoArea) {
                  e.stopPropagation();
                  e.preventDefault();
                  onQuotedClick(e);
                }
              }
            }
          }}
        >
          <VideoPlayer
            outerTimeStyle={outerTimeStyle}
            onLoad={() => handleLoading(false)}
            src={videos_?.[0]}
            height="100%"
            // getVideoDuration={(e) => console.log()}
            width="100%"
            style={{
              backgroundColor: 'black',
              // maxHeight: '70vh',
              borderRadius:"20px",
              width: '100%',
              height: '100%',
            }}
            className="player"
          />
        </Box>
      ) : (
        <>
          {isArticle ? (
            <>
              {cover_image && (
                // <Image
                //   className={styles.preloadImage}
                //   src={cover_image}
                //   lazy
                //   htmlHeight="auto"
                //   htmlWidth="100%"
                //   alt={'Post Image'}
                // />
                <Image className={styles.preloadImage} src={cover_image} alt={title} width="640" height="300" loading="lazy" />
              )}
            </>
          ) : (
            <>
              {images_?.length ? (
                images_.length > 1 ? (
                  <>
                    {images_.length === 5 ? (
                      // Custom grid layout for 5 images
                      <FiveImagesGrid images={images_} />
                    ) : (
                      // Default masonry layout for other cases
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{ 350: 1, 750: 1, 900: images_?.length > 3? 2 : 2 }}
                      >
                        <Masonry columnsCount={1} gutter="2px">
                          {images_?.map?.((img, index) => (
                            <>
                            
                            <ImageChakra key={Math.random()}  style={{
                              height: `${images_?.length ==2?'300px': (index+1 == images_?.length-1 &&images_?.length == 3)?'400px' :'200px'}`,
                              filter: `${(index+1 ==images_?.length-1 &&images_?.length > 4)?'brightness(0.5)':''}`,
                              objectFit:'cover',
                              // borderRadius:"20px"

                              ...(images_?.length === 2
                                ? {
                                    borderTopLeftRadius: index === 0 ? '20px' : '0px',
                                    borderBottomRightRadius: index === 1 ? '20px' : '0px',
                                    borderTopRightRadius: index === 0 ? '0px' : '20px',
                                    borderBottomLeftRadius: index === 1 ? '0px' : '20px',
                                  }
                                : images_?.length === 4
                                ? {
                                    borderTopLeftRadius: index === 0 ? '20px' : '0px',
                                    borderTopRightRadius: index === 1 ? '20px' : '0px',
                                    borderBottomLeftRadius: index === 2 ? '20px' : '0px',
                                    borderBottomRightRadius: index === 3 ? '20px' : '0px',
                                  }
                                :images_?.length === 3
                                ? {
                                  borderTopLeftRadius: index === 0 ? '20px' : '0px',
                                  borderBottomRightRadius: index === 0 ? '0px 0px' : '0px',
                                  borderTopRightRadius: index === 1 ? '20px' : '0px',
                                  borderBottomLeftRadius: index === 2 ? '20px' : '0px',
                                  borderBottomRightRadius: index === 2 ? '0px' : '20px',
                                }
                                :{

                                }),
                            
                            }}  src={img} alt={id} width="300" height="300" loading="lazy" />
                            {/* {(index+1 ==images_?.length-1 && images_?.length > 4)&&
                              <Stack style={{position: 'absolute',top: '74%',left: '76%',transform: 'translate(-50%, -50%)',textAlign: 'center'}}>
                              <Text size="2rem" color="#ffffff">+ {images_?.length - 4}</Text>
                                  </Stack>
                            } */}
                            
                            </>
                          ))}
                        </Masonry>
                      </ResponsiveMasonry>
                    )}
                  </>
                ) : (
                  <>
                    {/* <PreloadImage
                      className={styles.preloadImage}
                      src={images_?.[0]}
                      lazy
                    /> */}
                    <div className={`${styles.postImgContainer} ${imageAlignment === 'center' ? styles.centerAlign : styles.leftAlign}`}>
                      <img
                        src={images_?.[0]}
                        alt={id}
                        className={styles.postImage}
                      />
                    </div>
                  </>
                )
              ) : (
                <>
                  {gifs_?.length ? (
                    <Box pos="relative">
                      {/* <Image
                        className={styles.preloadImage}
                        src={gifs_?.[0]}
                        lazy
                        htmlHeight="400px"
                        htmlWidth="100%"
                        alt={'Post Image'}
                      /> */}
                      <ImageChakra
                        className={styles.preloadImage}
                        src={gifs_?.[0]}
                        alt={id}
                        width="516"
                        height="516"
                        borderRadius="20px"
                        loading="lazy"
                      />
                      <></>
                    </Box>
                  ) : (
                    ''
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {isAdPost && ad_format_detail?.image ? <Image className={styles.preloadImage} src={ad_format_detail?.image} alt={id} width="640" height="300" loading="lazy" /> : ''}
      {isAdPost && ad_format_detail?.video ? <Box 
          pos="relative" 
          overflow="hidden" 
          className={styles.mediaPlayer}
          onClick={(e) => {
            // Handle clicks on video area for quoted posts
            if (isQuoted && onQuotedClick) {
              const target = e.target;
              // Check if click is on video controls - look for specific video player control classes
              const isControlClick = 
                target.closest('[class*="controlCont"]') || // control container
                target.closest('[class*="playBtns"]') || // play/pause button
                target.closest('[class*="btnsCont"]') || // buttons container
                target.closest('[class*="barCont"]') || // progress bar container
                target.closest('input[type="range"]') || // slider controls
                target.closest('button') ||
                target.tagName === 'BUTTON' ||
                target.closest('svg') || // icon buttons
                target.closest('[role="button"]');
              
              // If clicking on video area (not controls), open windowed mode
              // Only handle if it's not a control click
              if (!isControlClick) {
                // Check if click is on the video player container, ReactPlayer, or video element
                const isVideoArea = target.closest('.player') || 
                                   target.closest('[class*="mediaPlayer"]') ||
                                   target.tagName === 'VIDEO' ||
                                   target === e.currentTarget;
                
                if (isVideoArea) {
                  e.stopPropagation();
                  e.preventDefault();
                  onQuotedClick(e);
                }
              }
            }
          }}
        >
          <VideoPlayer
            onLoad={() => handleLoading(false)}
            src={ad_format_detail?.video}
            height="100%"
            width="100%"
            ref={videoRef}
            getVideoDuration={(e) => handleVideoAdDuration(e)}
            style={{
              backgroundColor: 'black',
              maxHeight: '70vh',
              width: '100%',
              height: '100%',
            }}
            className="player"
          />
        </Box> : ''}
    </>
  );
};